<template>
  <router-link to="/" class="h-decoration-none">
    <h1 class="logo">KRYNOLINA</h1>
  </router-link>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  color: $fonts;
  text-decoration: none;
}
</style>